/** 文本路径 */
import { Vue, Component } from "vue-property-decorator";
@Component
export default class FontPathMixin extends Vue {
    get isSelect() {
        return !!this.$store.state.shape.isActived;
    }
    get isTextPath() {
        return this.$store.state.shape.fontFmt.isTextPath;
    }
    get commonTrackFlagAround() {
        return this.$store.state.floatTool.commonTrackFlag.fontAround;
    }

    fontAroundList: Array<{ id: number; text: string; name: string }> = [
        {
            id: 0,
            text: "",
            name: "font-around-1",
        },
        {
            id: 1,
            text: "",
            name: "font-around-2",
        },
        {
            id: 2,
            text: "",
            name: "font-around-3",
        },
        {
            id: 3,
            text: "",
            name: "font-around-4",
        },
        {
            id: 4,
            text: "",
            name: "font-around-5",
        },
        {
            id: 5,
            text: "",
            name: "font-around-6",
        },
        {
            id: 6,
            text: "",
            name: "font-around-7",
        },
        {
            id: 7,
            text: "",
            name: "font-around-8",
        },
        {
            id: 8,
            text: "",
            name: "font-around-9",
        },
        {
            id: 9,
            text: "",
            name: "font-around-10",
        },
        {
            id: 10,
            text: "",
            name: "font-around-11",
        },
        {
            id: 11,
            text: "",
            name: "font-around-12",
        },
        {
            id: 12,
            text: "",
            name: "font-around-13",
        },
        {
            id: 13,
            text: "",
            name: "font-around-14",
        },
        {
            id: 14,
            text: "",
            name: "font-around-15",
        },
    ];

    clickAround(index) {
        if (index == 15 && !this.isTextPath) return;
        window["_view"].editStyle("textOnPath", index);
        if (!this.commonTrackFlagAround) {
            this.sensors.track("commonTool", {
                Catalogues: "shortcutToolbar",
                content: "fontAround",
            });
            this.$store.commit("setCommonTrackFlag", {
                fontAround: 1,
            });
        }
    }
}
